export const formatCurrency = v =>
  '$' + v.toFixed(2)
